import axios from "axios";
import { typeUser } from "../pages/Admin/AdminLogin/AdminLoginApi";

export const VERSION = 3;

const adminAxios = ({ user }: { user: typeUser }) => {
  const userOrganisation = user.userOrganisations.filter(
    ({ organisation }) =>
      organisation.uuid ===
      process.env.REACT_APP_HAVEFUN_ONLINE_BOOKING_ORGANISAITON_UUID
  );
  if (!userOrganisation) {
    return axios.create({
      baseURL: process.env.REACT_APP_EXABLOOM_SERVICE_URL,
      headers: {
        version: process.env.REACT_APP_EXABLOOM_SERVICE_VERSION ?? VERSION,
        agencyUuid:
          process.env.REACT_APP_HAVEFUN_AGENCY_UUID,
        organisationuuid:
          process.env.REACT_APP_HAVEFUN_ONLINE_BOOKING_ORGANISAITON_UUID,
      },
    });
  }
  return axios.create({
    baseURL: process.env.REACT_APP_EXABLOOM_SERVICE_URL,
    withCredentials: true,
    headers: {
      version: process.env.REACT_APP_EXABLOOM_SERVICE_VERSION ?? VERSION,
      agencyUuid:
        process.env.REACT_APP_HAVEFUN_AGENCY_UUID,
      organisationuuid:
        process.env.REACT_APP_HAVEFUN_ONLINE_BOOKING_ORGANISAITON_UUID,
    },
  });
};

export default adminAxios;
